import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { ActionRouterLinkModule } from '@app/components/actions/action-router-link/action-router-link.component';
import { CompactFeaturedNewsModule } from '@app/components/compact-featured-news/compact-featured-news.component';
import { CompactYourNewsModule } from '@app/components/compact-your-news/compact-your-news.component';
import { LinkModule } from '@app/directives/link.directive';
import { FeatureSettingsStoreService } from '@app/services/feature-settings-store.service';

@Component({
  selector: 'app-news-layout',
  templateUrl: './news-layout.component.html',
  styleUrls: ['./news-layout.component.scss']
})
export class NewsLayoutComponent implements OnInit {

  newsCenterUrl: string;
  cardsGridLayoutClass: string;
  workplaceName: string;
  selectedIndex = 0;
  constructor(private featureSettingsStoreService: FeatureSettingsStoreService) {
    this.newsCenterUrl = `${this.featureSettingsStoreService.state.newsArchiveLink}`;
    this.workplaceName = this.featureSettingsStoreService.state.workplaceName;
  }

  ngOnInit(): void {
  }

}

@NgModule({
  declarations: [NewsLayoutComponent],
  exports: [
    NewsLayoutComponent
  ],
  imports: [
    CommonModule,
    LinkModule,
    CompactYourNewsModule,
    MatButtonModule,
    CompactFeaturedNewsModule,
    RouterModule,
    ActionRouterLinkModule
  ]
})
export class NewsLayoutModule { }
